import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class MessageThoughtBubble extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.circles = null;
    this.lblThought = null;

    const sizes = [0.10,0.2,0.3,1.0];
    const pos = [[42,300],[40,262],[47,210],[72,100]];
    this.circles = [];

    const len = sizes.length;
    let b = null;
    for (let i = 0; i < len; i++) {
      b = ABCyaPhaser.Images.addImage(pos[i][0], pos[i][1], UIAssetKeys._ResultsMessageBg, this).setScale(sizes[i]);
      b.destSize = sizes[i];
      this.circles.push(b);
    }
    this.lblThought = ABCyaPhaser.Text.addText(this.circles[this.circles.length - 1].x, this.circles[this.circles.length - 1].y, 54, 0x006699,FontKeys._bpreplaybold, '.', this, true).setOrigin(0.5)
      .setVisible(false);
  }

  initForThought (value) {
    const len = this.circles.length;
    let b = null; let waitTime = 0;
    for (let i = 0; i < len; i++) {
      b = this.circles[i];
      b.scale = 0;
      this.scene.tweens.killTweensOf(b);
      ABCyaPhaser.Tweens.addTween(b, 120, { delay: waitTime, alpha: 1, scale: b.destSize }, Phaser.Math.Easing.Quadratic.Out);
      waitTime += 60;
    }

    this.scene.tweens.killTweensOf(this);
    this.scene.time.delayedCall(waitTime + 120, this.displayThoughtText, [value], this);
  }

  displayThoughtText (value) {
    this.lblThought.text = value.toString();
    this.lblThought.alpha = 0;
    this.lblThought.setVisible(true);
    ABCyaPhaser.Tweens.addTween(this.lblThought, 440, { alpha: 1, completeDelay: 2900 }, Phaser.Math.Easing.Quadratic.Out, () => this.thoughtGoAway());
  }

  thoughtGoAway () {
    this.scene.tweens.killTweensOf(this.lblThought);
    ABCyaPhaser.Tweens.addTween(this.lblThought, 120, { alpha: 0 }, Phaser.Math.Easing.Linear);

    const len = this.circles.length;
    let b = null; let waitTime = 130;
    for (let i = len - 1; i >= 0; i--) {
      b = this.circles[i];
      this.scene.tweens.killTweensOf(b);
      ABCyaPhaser.Tweens.addTween(b, 220, { delay: waitTime, alpha: 0, scale: 0 }, Phaser.Math.Easing.Quadratic.In);

      waitTime += 96;
    }

    this.scene.tweens.killTweensOf(this);
    this.scene.time.delayedCall(waitTime, this.thoughtOver, null, this);
  }

  thoughtOver () {
    this.emit('THOUGHT_OVER');
  }
}